import { APP_ROUTES } from '@/constants/pages';
import { getSERPBreadcrumbs, isSistaminuten, url } from '@/helpers';
import { getBreadcrumbsSchema, getSearchResultsPageSchema } from '@/helpers/jsonld';
import { SearchManagerOutput } from '@/hooks/search/useSearch';
import { getLocale } from '@/locale';
import { Helmet } from 'react-helmet';
import { useLocation, useRouteMatch } from 'react-router-dom';
import { getSeoProps } from '../pages/index.helpers';

const SEO = (search: SearchManagerOutput) => {
  const location = useLocation();
  const match = useRouteMatch();
  const isIndexable = match.path === APP_ROUTES.SERP || match.path === APP_ROUTES.SISTA_MINUTEN_SERP;
  const seo = getSeoProps(search, location);
  const ogLocale = getLocale().replace('-', '_');

  const breadcrumbs = getSERPBreadcrumbs(search.q, search.location).map((item) => ({
    ...item,
    url: `${url.getBaseUrl()}${(item.url ?? '').slice(1)}`,
  }));

  return (
    <Helmet encodeSpecialCharacters={true}>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="keywords" content={seo.keywords} />
      <link rel="canonical" href={seo.canonical} />
      <meta property="og:url" content={seo.url} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:locale" content={ogLocale} />
      <meta property="og:image" content={seo.image} />
      <meta property="og:description" content={seo.description} />
      {!isSistaminuten() && <meta property="og:site_name" content="Bokadirekt" />}
      {!isSistaminuten() && <meta name="twitter:card" content="summary" />}
      {!isSistaminuten() && <meta name="twitter:site" content="@bokadirekt" />}
      {(!isIndexable || search.isIndexable === false) && <meta name="robots" content="noindex, follow" />}
      {seo.prev}
      {seo.next}
      <script type="application/ld+json">{getSearchResultsPageSchema(search.places[search.page] || [])}</script>
      <script type="application/ld+json">{getBreadcrumbsSchema(breadcrumbs)}</script>
    </Helmet>
  );
};

export default SEO;
